import moment from 'moment';
import { BillingDetails, Invoice } from 'shared/classes/Billing';

export function Customer(data = {}) {
	var self = this;
	self.type = "Customer"

	self.rootvm = data.rootvm;

	self.customer_uuid = ko.observable(data.customer_uuid);
	self.customer_name = ko.observable(data.name);
};

export function Project(data = {}) {
	var self = this;
	self.type = "Project"

	self.rootvm = data.rootvm;

	self.project_uuid = ko.isObservable(data.project_uuid) ? data.project_uuid : ko.observable(data.project_uuid);
	self.id = ko.isObservable(data.id) ? data.id : ko.observable(data.id);
	self.title = ko.isObservable(data.title) ? data.title : ko.observable(data.title);
	self.customer_uuid = ko.isObservable(data.customer_uuid) ? data.customer_uuid : ko.observable(data.customer_uuid);
	self.customer_name = ko.isObservable(data.customer_name) ? data.customer_name : ko.observable(data.customer_name);
	self.cost_center = ko.isObservable(data.cost_center) ? data.cost_center : ko.observable(data.cost_center);

	self.income = ko.isObservable(data.income) ? data.income : ko.observable(data.income);
	self.expenses = ko.isObservable(data.expenses) ? data.expenses : ko.observable(data.expenses);
	self.profit_margin = ko.pureComputed(() => {
		return (self.income()-self.expenses())/self.income()*100
	});
	self.profit_margin_total = ko.pureComputed(() => {
		return self.income()-self.expenses()
	});

	self.inserted = ko.isObservable(data.inserted) ? data.inserted : ko.observable(new moment(data.inserted));
	self.updated = ko.isObservable(data.updated) ? data.updated : ko.observable(new moment(data.updated));

	self.new_customer = ko.observable(false);

	self.extra_notes = ko.isObservable(data.extra_notes) ? data.extra_notes : ko.observable(data.extra_notes);
	self.new_extra_notes = ko.isObservable(data.new_extra_notes) ? data.new_extra_notes : ko.observable(data.extra_notes);
	self.editing_extra_notes = ko.observable(false);
	self.cancel_extra_notes = function () {
		self.new_extra_notes(self.extra_notes());
		self.editing_extra_notes(false);
	}

	self.save_extra_notes = function () {

		return $.ajax({

			url: self.rootvm.web_host + '/api/admin/project/extra-notes',
			type: 'POST',
			data: ko.toJSON({
				project_uuid: self.project_uuid(),
				extra_notes: self.new_extra_notes()
			}),
			processData: false,

			contentType: "application/json; charset=utf-8",

			success: function (data) {

				if (data.success) {

					self.extra_notes(data.extra_notes);
					self.new_extra_notes(data.extra_notes);
					self.editing_extra_notes(false);
					notyf.success("Saved!");
				}
				else {
					notyf.error(data.message);
				}

			},
			error: function (jqXHR, errorStatus, thrownError) {
				var response = jQuery.parseJSON(jqXHR.responseText);
				notyf.error(response.message);
			},
			complete: function () {
			}
		});
	};

	self.is_valid = ko.pureComputed(() => {
		return self.title() && self.cost_center() && (
			(self.customer_uuid() && !self.new_customer()) ||
			(self.customer_name() && self.new_customer())
		)
	});
};


export function ExternalBalance(data) {
	var self = this;
	self.type = "ExternalBalance"

	self.external_balance_uuid = ko.observable(data.external_balance_uuid);
	self.external_balance_amount = ko.observable(data.external_balance_amount);
	self.external_balance_netto = ko.observable(data.external_balance_netto);
	self.locale_external_balance = ko.pureComputed(() =>
		Intl.NumberFormat(undefined, { style: 'currency', currency: 'EUR' }).format(self.external_balance_amount())
	);
	self.locale_external_balance_netto = ko.pureComputed(() =>
		Intl.NumberFormat(undefined, { style: 'currency', currency: 'EUR' }).format(self.external_balance_netto())
	);

	self.external_balance_date = ko.observable(data.external_balance_date);
	self.pretty_external_balance_date = ko.pureComputed(function () {
		if (self.external_balance_date()) {
			return (new Date(self.external_balance_date())).toLocaleDateString()
		}
	});
	self.cost_center = ko.observable(data.cost_center);
	self.external_cloud_link = ko.observable(data.external_cloud_link);

	self.external_balance_invoice_number = ko.observable(data.external_balance_invoice_number);
	self.is_expense = ko.observable(data.is_expense);

	self.payin_date = ko.observable();
	if (data.payin_date) {
		self.payin_date(new moment(data.payin_date));
	}
	self.pretty_payin_date = ko.pureComputed(function () {
		if (self.payin_date()) {
			return self.payin_date().format('DD.MM.YY')
		}
	});

	self.due_date = ko.observable(data.due_date && data.due_date.includes("T") ? data.due_date.split("T")[0] : data.due_date);
	self.pretty_due_date = ko.pureComputed(function () {
		if (self.due_date()) {
			return (new Date(self.due_date())).toLocaleDateString()
		}
	});

	self.receiver_name = ko.observable(data.receiver_name);

	self.extra_notes = ko.observable(data.extra_notes);
	self.project_uuid = ko.observable(data.project_uuid);
	self.project_title = ko.observable(data.project_title || '');

	self.mark_as_paid_in = function () {

		var answer = confirm('Confirm external invoice Payin RS-' + self.external_balance_invoice_number());

		if (answer) {
			return $.ajax({

				url: '/api/admin/external-balance/pay-in',
				type: 'POST',
				data: ko.toJSON({
					external_balance_uuid: self.external_balance_uuid(),
				}),
				processData: false,


				contentType: "application/json; charset=utf-8",

				success: function (data) {

					if (data.success) {
						console.log(data.payin_date);
						self.payin_date(new moment(data.payin_date));
						notyf.success("Paid!");
					}
					else {
						notyf.error(data.message || 'Something did not work right');
					}

				},
				error: function (data) {
					notyf.error(data);
				},
				complete: function () {
				}
			});
		}
	};

}

export function Expense(data = {}) {
	const self = this;
	self.type = "Expense"

	self.expense_uuid = ko.observable(data.expense_uuid);
	self.asp = ko.observable(data.asp);
	self.amount = ko.observable(data.amount);
	self.currency = ko.observable(data.currency ||'EUR');
	self.date = ko.observable(data.date);
	self.date_moment_obj = new moment(data.date);
	self.receiver_name = ko.observable(data.receiver_name);
	self.invoice_number = ko.observable(data.invoice_number);
	self.receipt = ko.observable(data.receipt);
	self.rs_number = ko.observable(data.rs_number);
	self.fee_number = ko.observable(data.fee_number);
	self.datevk = ko.observable(data.datevk);
	self.datevw = ko.observable(data.datevw);
	self.vat_id = ko.observable(data.vat_id);
	self.cost_center = ko.observable(data.cost_center);
	self.paid_details = ko.observable(data.paid_details);
	self.cloud_link = ko.observable(data.cloud_link);
	self.extra_notes = ko.observable(data.extra_notes);
	self.project_uuid = ko.observable(data.project_uuid);
	self.project_title = ko.observable(data.project_title || '');
	self.is_fee = ko.observable(data.is_fee || false);
	self.is_processed = ko.observable(data.is_processed || false);
	self.related_external = ko.observable(data.related_external);
	self.related_fee_invoice = ko.observable(data.related_fee_invoice);
	self.fee_pdf = ko.observable(data.fee_pdf);
	self.fee_paid_date = ko.observable(data.fee_paid_date);
	self.rs_link = ko.observable(data.rs_link);
	self.inserted = ko.observable(data.inserted);
	self.updated = ko.observable(data.updated);
	self.deleted = ko.observable(data.deleted);

	self.fee_invoice = ko.observable(data.fee_invoice || new Invoice({
		invoice_uuid: data.related_fee_invoice,
		invoice_number: data.fee_number,
		invoice_type: 'fee',
		paid_date: data.fee_paid_date,
		selected_payment_method: data.fee_payment_method,
		commission_tax_mode_home_country: data.commission_tax_mode_home_country
	}))

	self.is_fee.subscribe((newVal) => {
		if (newVal) {
			self.receiver_name(undefined);
			self.invoice_number(undefined);
			self.receipt(undefined);
		} else {
			self.rs_number(undefined);
			self.fee_number(undefined);
		}
	});

	self.is_valid = ko.pureComputed(function () {
		const alwaysRequired = (self.asp()) ? true : false;
		const feeRequired = (self.rs_number() >= 0 && self.fee_number() > 0) ? true : false;
		const notFeeRequired = (self.receiver_name() && self.invoice_number() && self.amount() && self.date()) ? true : false;
		return self.is_fee() ? alwaysRequired && feeRequired : alwaysRequired && notFeeRequired;
	});

	self.is_busy = ko.observable(false);
	self.billing_details = ko.observable(new BillingDetails({}));
	self.lookup_invoice = async () => {
		self.is_busy(true);
		const url = scvm.web_host + '/api/admin/expense/invoice-details'
		const params = new URLSearchParams({
			invoice_number: self.fee_number()
		})
		const request = new Request(
			url + '?' + params.toString(), {
			method: 'GET',
			headers: new Headers({
				'Content-Type': 'application/json'
			})
		});
		const response = await fetch(request);
		const data = await response.json();
		self.is_busy(false);
		if (data.success) {
			self.billing_details(new BillingDetails(data.billing_details));
		} else {
			console.error(data.pgcode, data.pgerror);
			throw new Error(data.message)
		}
	};
}
